// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__13AF6","content":"ManualTimeModal_content__3GowU"};